import {
  useDocFlowContext,
  useDocFlowEpostSettingsWidget,
  useDocFlowSendingContext,
} from '../../DocFlow.hooks'
import { DocFlowSendingWidgetProcessFieldName } from '../../DocFlowSending'
import { DocFlowSendingWidgetContent } from '../DocFlowSendingWidgetContent'

function DocFlowSendingEpostSettingsWidget({ index, ...restProps }) {
  const { phaseDisabled } = useDocFlowContext()

  const { epostNotificationsData, isCalculating, isEpostSettingsLoading } =
    useDocFlowSendingContext()

  const { handleClickNext, handleClickPrevious, isError } =
    useDocFlowEpostSettingsWidget({
      index,
    })

  return (
    <DocFlowSendingWidgetContent
      {...restProps}
      actionsProps={{
        disabled: (isCalculating || isEpostSettingsLoading) && !phaseDisabled,
      }}
      index={index}
      isError={isError}
      notifications={epostNotificationsData.notifications}
      widgetStatusFieldName={
        DocFlowSendingWidgetProcessFieldName.EpostSettingsPhase
      }
      onClickPrevious={handleClickPrevious}
      onSubmit={handleClickNext}
    />
  )
}

export default DocFlowSendingEpostSettingsWidget
